<template lang="pug">
    v-dialog(v-model="dialog" max-width="480" scrollable persistent :fullscreen="$vuetify.breakpoint.smAndDown")
        v-card(tile)
            v-overlay(:value="fileUploading" absolute)
                v-progress-circular(indeterminate size="64")
            v-card-title.title.caption--text {{title}}
            v-container(tag="v-card-text" gris-list-xl)
                v-form(id="form_34545dfgdsfg" ref="refForm" @submit="onSubmit")
                    v-layout(wrap)
                        v-file-input(
                            v-if="mode === 'create'"
                            :rules="imageRules"
                            v-model="image"
                            show-size clearable
                            accept="image/*"
                            :label="$t('pages.settings.system.backgroundImageDialog.image')"
                            prepend-icon="mdi-camera"
                            @change="onChangeFileInput"
                        )
                        v-flex(xs12)
                            v-text-field(v-model="detail" ref="refDetail" :label="$t('pages.settings.system.backgroundImageDialog.detail')" counter=100
                                prepend-icon="mdi-note-text-outline" clearable
                            :rules="[rules.required, rules.maxLength(detail, 100)]")
                        v-flex(xs12)
                            v-checkbox(v-model="published" :label="mode === 'create' ? $t('pages.settings.system.backgroundImageDialog.publishNow') : $t('pages.settings.system.backgroundImageDialog.publish')")
                        v-flex(xs12 v-if="mode === 'create'")
                            v-checkbox(v-model="addOnTop" :label="$t('pages.settings.system.backgroundImageDialog.addOnTop')")
            v-card-actions
                v-btn(@click="close" color="grey" depressed).px-3.white--text
                    v-icon(left dark) mdi-cancel
                    | {{$t('general.cancel')}}
                v-spacer
                v-btn(type="submit" form="form_34545dfgdsfg" color="primary" depressed).px-3
                    v-icon(left dark) mdi-content-save
                    | {{$t('general.save')}}
</template>

<script>
import rules from "../../mixins/rules";
import general from "../../mixins/general";
import crud from "../../mixins/crud";

export default {
  name: "BackgroundImageEditDialog",
  mixins: [rules, general, crud],
  data() {
    return {
      mode: "create",
      dialog: false,
      currentId: null,
      detail: "",
      published: false,
      media_id: 0,
      url: "",
      image: null,
      fileUploading: false,
      cancelUpload: null,
      addOnTop: true
    };
  },
  computed: {
    imageRules() {
      return [
        this.rules.required,
        value =>
          !value ||
          value.size < 1000000 ||
          "Image size should be less than 1 MB!"
      ];
    },
    showing: {
      get() {
        return this.dialog;
      }
    },
    title: {
      get() {
        return this.$t(
          `pages.settings.system.backgroundImageDialog.title.${this.mode}`
        );
      }
    }
  },
  watch: {
    image(value, before) {
      if (value && value.name && typeof value.name === "string") {
        let fillDetail = !this.detail;
        if (
          !fillDetail &&
          before &&
          before.name &&
          typeof before.name === "string"
        ) {
          let idx = before.name.lastIndexOf(".");
          const oldName = before.name.substring(
            0,
            idx > -1 && idx < 100 ? idx : 99
          );
          fillDetail = oldName === this.detail;
        }

        if (fillDetail) {
          const idx = value.name.lastIndexOf(".");
          this.detail = value.name.substring(
            0,
            idx > -1 && idx < 100 ? idx : 99
          );
        }
      } else if (before && before.name && typeof before.name === "string") {
        let idx = before.name.lastIndexOf(".");
        const oldName = before.name.substring(
          0,
          idx > -1 && idx < 100 ? idx : 99
        );
        if (oldName === this.detail) {
          this.detail = "";
        }
      }
    }
  },
  methods: {
    clear() {
      this.image = null;
      this.currentId = 0;
      this.detail = "";
      this.published = false;
      this.media_id = 0;
      this.url = "";
    },
    show(mode, data = null) {
      this.clear();
      this.mode = mode;
      this.dialog = true;
      this.$nextTick(() => {
        this.$refs["refForm"].resetValidation();
        if (mode === "edit" && data) {
          this.currentId = data.id;
          this.detail = data.detail;
          this.published = data.published;
          this.url = data.url;
        }
      });
    },
    close() {
      this.dialog = false;
    },
    onChangeFileInput(value) {
      if (value && this.showing) {
        this.$nextTick(() => {
          this.$refs["refDetail"].focus();
        });
      }
    },
    onSubmit(e) {
      e.preventDefault();
      if (this.$refs["refForm"].validate()) {
        this.$confirm(this.$t("messages.saveConfirmation")).then(
          async value => {
            if (value) {
              if (this.mode === "create") {
                const body = new FormData();
                body.append("image", this.image);
                this.fileUploading = true;
                let self = this;
                const uploadedFile = await this.axios
                  .post(`upload-image`, body, {
                    cancelToken: new this.axios.CancelToken(function executor(
                      c
                    ) {
                      self.cancelUpload = c;
                    })
                  })
                  .then(response => {
                    this.fileUploading = false;
                    // this.$toasted.info("File Uploaded");
                    return response.data.data;
                  })
                  .catch(error => {
                    this.fileUploading = false;
                    if (this.axios.isCancel(error)) {
                      this.$toasted.error(error.message, { icon: "mood_bad" });
                    } else {
                      this.saveErrorHandler(error);
                    }
                  })
                  .finally(() => (this.cancelUpload = null));
                if (!uploadedFile) return;
                this.media_id = uploadedFile.id;
              }

              this.close();
              this.$emit("save", {
                mode: this.mode,
                id: this.currentId,
                body: {
                  detail: this.detail,
                  published: this.published,
                  media_id: this.media_id,
                  top: this.addOnTop
                }
              });
            }
          }
        );
      }
    }
  }
};
</script>
